import React, { useState, useEffect, useMemo } from "react";
import { RiArrowLeftSLine } from "react-icons/ri";

const BaseLayout = ({ children, SidebarComponent, sidebarProps, islogin }) => {
  const [toggled, setToggled] = useState(false);
  const [isDesktopCollapsed, setIsDesktopCollapsed] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isTabletView, setIsTabletView] = useState(false);
  const [showMenuButton, setShowMenuButton] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobileView(width < 600);
      setIsTabletView(width >= 600 && width < 1000);
      if (width >= 1000) {
        setToggled(false);
      }
      if (width < 600) {
        setToggled(false);
      }
    };
    const handleScroll = () => {
      if (window.scrollY >= 100) {
        setShowMenuButton(true);
      } else {
        setShowMenuButton(false);
      }
    };

    handleScroll();
    handleResize();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleDesktopCollapse = () => setIsDesktopCollapsed((prev) => !prev);

  const mainContentClass = () => {
    if (isMobileView) {
      return "main-content-mobile";
    } else if (isTabletView) {
      return toggled
        ? "main-content-tablet-toggled"
        : "main-content-tablet-collapsed";
    } else {
      return isDesktopCollapsed
        ? "main-content-desktop-collapsed"
        : "main-content-desktop-expanded";
    }
  };

  const contextValue = useMemo(
    () => ({
      collapsed: isDesktopCollapsed,
      setCollapsed: handleDesktopCollapse,
      toggled,
      setToggled,
      isMobileView,
      isTabletView,
      islogin,
    }),
    [isDesktopCollapsed, toggled, isMobileView, isTabletView, islogin]
  );

  return (
    <div className="min-vh-100 layout has-sidebar fixed-sidebar fixed-header relative">
      {/* {(isMobileView || isTabletView) && !toggled && (
        <div className="psb-mobile-trigger" onClick={() => setToggled(true)}>
          <RiArrowLeftSLine style={{ fontSize: "18px" }} /> Menu
        </div>
      )} */}
      {(isMobileView || isTabletView) && !toggled && showMenuButton && (
        <div
          className="psb-mobile-trigger"
          onClick={() => setToggled(true)}
          style={{
            opacity: showMenuButton ? 1 : 0,
            transform: showMenuButton ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.3s ease, transform 0.3s ease",
            pointerEvents: showMenuButton ? "auto" : "none",
          }}
        >
          <RiArrowLeftSLine style={{ fontSize: "18px" }} /> Menu
        </div>
      )}

      {SidebarComponent && (
        <SidebarComponent
          {...sidebarProps}
          collapsed={isDesktopCollapsed}
          setCollapsed={handleDesktopCollapse}
          toggled={toggled}
          setToggled={setToggled}
          isMobileView={isMobileView}
          isTabletView={isTabletView}
        />
      )}

      <div className={`main-content ${mainContentClass()}`}>
        {React.Children.map(children, (child) =>
          React.isValidElement(child)
            ? React.cloneElement(child, contextValue)
            : child
        )}
      </div>

      {(isMobileView || isTabletView) && toggled && (
        <div className="psb-overlay" onClick={() => setToggled(false)} />
      )}
    </div>
  );
};

export default BaseLayout;
